module.exports = __webpack_public_path__ + "static/img/01-友链5.6685a28.png";


//////////////////
// WEBPACK FOOTER
// ./public/pc/01-友链5.png
// module id = nTla
// module chunks = 14